import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import commonDataKeys from './keys';
import getAcitveWOByCont from '../../../service/Common/Get/getAcitveWOByCont';

const useGetActuveWOByCont = ({ contNo }) => {
  const [activeWOList, setActiveWOList] = useState([]);

  const query = useQuery({
    queryKey: commonDataKeys?.activeWOList({ contNo }),
    queryFn: () => getAcitveWOByCont({ params: { cont_no: contNo } }),
    refetchOnWindowFocus: false,
    enabled: !!contNo,
  });

  useEffect(() => {
    if (query?.data) {
      setActiveWOList(prev => query?.data?.data);
    } else {
      setActiveWOList(perv => []);
    }
  }, [query?.data]);

  return { activeWOList, ...query };
};

export default useGetActuveWOByCont;
